import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey4, grey10 } from 'approot/shared/styles/colours.style';
import { ModalCloseButtonStyled } from 'approot/shared/styles/buttons/modal-close-button.style';
import {
  spacing8,
  spacing16,
  spacing48,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import {
  LAYOUT_HEADER_HEIGHT,
  LayoutDrawerStyled,
  LayoutMultiViewPageStyled,
} from 'approot/shared/layout/layout.styles';
import {
  fontSize14,
  fontSize14LineHeight,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import {
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_DRAWER_OVERLAY_Z_INDEX,
  ACTIVITY_BUILDER_SETTINGS_DRAWER_Z_INDEX,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from './activity-builder.constants';

type ActivityBuilderDrawerProps = {
  $isActive: boolean;
};
export const ActivityBuilderDrawer = styled.div<ActivityBuilderDrawerProps>`
  position: fixed;
  right: 0;
  bottom: 0;
  flex-shrink: 0;
  top: 0;
  width: ${({ $isActive }) => ($isActive ? `100vw` : 0)};
  z-index: ${ACTIVITY_BUILDER_DRAWER_OVERLAY_Z_INDEX};

  ${LayoutDrawerStyled} {
    position: absolute;
  }

  ${LayoutMultiViewPageStyled} {
    & > div {
      height: 100%;
      min-height: 100%;
    }
  }

  @media (min-width: 320px) {
    width: ${({ $isActive }) =>
      rem($isActive ? ACTIVITY_BUILDER_DRAWER_WIDTH : 0)};
  }

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    top: ${rem(LAYOUT_HEADER_HEIGHT)};
    z-index: ${ACTIVITY_BUILDER_SETTINGS_DRAWER_Z_INDEX};

    ${LayoutDrawerStyled} {
      border-left: 1px solid ${grey4};
      box-shadow: none;
      transition: none;
      right: ${rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
      width: ${({ $isActive }) =>
        rem($isActive ? ACTIVITY_BUILDER_DRAWER_WIDTH : 0)};
    }
  }
`;

export const ActivityBuilderDrawerIdWrapper = styled.div`
  height: 100%;
`;

type ActivityBuilderDrawerHeaderProps = {
  $hasHeaderButton?: boolean;
  $hasBorderBottom?: boolean;
};

export const ActivityBuilderDrawerHeader = styled.div<ActivityBuilderDrawerHeaderProps>`
  align-items: center;
  display: flex;
  ${({ $hasBorderBottom }) =>
    $hasBorderBottom &&
    `
    border-bottom: 1px solid ${grey4};
  `}

  flex-shrink: 0;
  height: ${rem(56)};
  padding: 0
    ${({ $hasHeaderButton }) =>
      $hasHeaderButton ? rem(spacing16) : rem(spacing48)}
    0 ${rem(spacing8)};
  position: relative;
`;

export const ActivityBuilderDrawerClose = styled(ModalCloseButtonStyled)`
  flex-shrink: 0;
  height: ${rem(32)};
  width: ${rem(32)};
  position: relative;
  right: auto;
  top: auto;
`;

type ActivityBuilderDrawerContentProps = {
  $padding?: number;
};
export const ActivityBuilderDrawerContent = styled.div<ActivityBuilderDrawerContentProps>`
  flex-grow: 1;
  padding: ${({ $padding = spacing16 }) => rem($padding)};
  position: relative;
  overflow: auto;
  overflow-x: hidden;
`;

export const ActivityBuilderDrawerTitle = styled.h1`
  ${flexCentreAlignCss}
  font-size: ${rem(fontSize14)};
  font-weight: ${fontWeightMedium};
  flex-grow: 1;
  line-height: ${rem(fontSize14LineHeight)};
  text-align: center;
  flex-shrink: 0;
  color: ${grey10};
  margin-bottom: 0;
`;

export const ActivityBuilderDrawerActions = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${rem(spacing24)};
  padding: ${rem(spacing16)};

  & > button {
    width: 100%;
  }
`;

export const ActivityBuilderDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  overflow: hidden;
`;

export const ActivityBuilderDrawerForm = styled.form`
  height: 100%;
`;
